module.exports = __webpack_public_path__ + "static/img/noright.b155324.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/noright.png
// module id = VKRc
// module chunks = 1